/**
 * Golf BPM Quiz — Shopify Version
 *
 * Amplitude is initialized here (not inline in the template) to avoid
 * Shopify's editor flagging inline script blocks.
 */
if (window.amplitude) {
    window.amplitude.init('db54847d026fb573c8cf8af97b82a12b', {
        fetchRemoteConfig: true,
        autocapture: {
            attribution:         true,
            pageViews:           true,
            sessions:            true,
            formInteractions:    true,
            elementInteractions: true
        }
    });
}

/**
 * What was removed from the app version:
 *   - jQuery Mobile navigation ($.mobile.changePage)
 *   - Firebase / Firestore sync
 *   - All auth (Apple, Google, email account creation)
 *   - RevenueCat / paywall
 *   - Cordova / Capacitor device events
 *   - Screens 13-15 (account, social proof, education)
 *
 * Screen 12 "Get My Plan" button redirects to the Shopify landing page.
 * Update LANDING_PAGE_URL below before deploying.
 */

// Redirect destination after quiz completion — the tempo reveal landing page.
// The quiz appends ?tempo=144 (or 156) so the landing page can personalise itself.
// ⚠️ Update this handle if you name the Shopify page differently.
var LANDING_PAGE_URL = '/pages/personalized-golf-swing-tempo';

// ============================================================================
// ONBOARDING DATA — localStorage
// ============================================================================

var OnboardingData = {
    init: function() {
        var existing = localStorage.getItem('onboardingData');
        if (!existing) {
            var initialData = {
                frustration:       '',
                focusArea:         '',
                handicap:          null,
                bestScore:         null,
                typicalScore:      null,
                swingTempoType:    '',
                golferType:        '',
                takesLessons:      '',
                practiceFrequency: '',
                backswingPosition: '',
                nineIronDistance:  null,
                primaryGoal:       '',
                fullSwingTempo:    null,
                puttingTempo:      135,
                primaryFocus:      '',
                currentScreen:     1,
                startedAt:         new Date().toISOString(),
                version:           '1.0'
            };
            localStorage.setItem('onboardingData', JSON.stringify(initialData));
            return initialData;
        }
        return JSON.parse(existing);
    },

    get: function() {
        var data = localStorage.getItem('onboardingData');
        return data ? JSON.parse(data) : this.init();
    },

    set: function(updates) {
        var current = this.get();
        var updated = Object.assign({}, current, updates);
        localStorage.setItem('onboardingData', JSON.stringify(updated));
        return updated;
    },

    completeScreen: function(screenNumber) {
        var current = this.get();
        current.currentScreen = screenNumber + 1;
        localStorage.setItem('onboardingData', JSON.stringify(current));
    },

    clear: function() {
        localStorage.removeItem('onboardingData');
    }
};

// ============================================================================
// FOCUS AREA MAPPING
// ============================================================================

function getFocusArea(frustration) {
    var focusMap = {
        'ball_striking': 'full_swing',
        'distance':      'full_swing',
        'putting':       'putting',
        'short_game':    'short_game',
        'inconsistency': 'full_swing',
        'driver':        'full_swing'
    };
    return focusMap[frustration] || 'full_swing';
}

// ============================================================================
// TEMPO CALCULATION
// ============================================================================

function getTempoRecommendations(onboardingData) {
    var frustration      = onboardingData.frustration;
    var nineIronDistance = onboardingData.nineIronDistance;

    // 9-iron distance is used as a swing speed proxy
    // > 140 yards → faster tempo (156 BPM), otherwise standard (144 BPM)
    var fullSwingTempo = nineIronDistance > 140 ? 156 : 144;

    return {
        fullSwingTempo: fullSwingTempo,
        puttingTempo:   135,
        primaryFocus:   getFocusArea(frustration)
    };
}

// ============================================================================
// SCREEN ORDER
// ============================================================================

var screenOrder = [
    'onboarding-handicap',      // 1
    'onboarding-frustration',   // 2
    'onboarding-tempo-type',    // 3
    'onboarding-golfer-type',   // 4
    'onboarding-lessons',       // 5
    'onboarding-practice',      // 6
    'onboarding-backswing',     // 7
    'onboarding-distance',      // 8
    'onboarding-goal',          // 9
    'onboarding-summary',       // 10
    'onboarding-calculating'    // 11 → calculates tempo then redirects to LANDING_PAGE_URL
];

// ============================================================================
// SCREEN NAVIGATION
// ============================================================================

function showScreen(screenId, reverse) {
    var currentActive = document.querySelector('.quiz-screen.active');
    if (currentActive) {
        currentActive.classList.remove('active');
    }

    var target = document.getElementById(screenId);
    if (!target) return;

    target.classList.remove('slide-in', 'slide-in-reverse');
    target.classList.add('active');

    // Force reflow so the animation triggers fresh each time
    void target.offsetWidth;
    target.classList.add(reverse ? 'slide-in-reverse' : 'slide-in');

    setTimeout(function() {
        target.classList.remove('slide-in', 'slide-in-reverse');
    }, 400);

    updateProgressBar(screenId);
    handleScreenShow(screenId);
    window.scrollTo(0, 0);
}

function goToNextScreen(currentScreenId) {
    var currentIndex = screenOrder.indexOf(currentScreenId);
    if (currentIndex >= 0 && currentIndex < screenOrder.length - 1) {
        showScreen(screenOrder[currentIndex + 1], false);
    }
}

function quizGoBack(currentScreenId) {
    var currentIndex = screenOrder.indexOf(currentScreenId);
    if (currentIndex > 0) {
        showScreen(screenOrder[currentIndex - 1], true);
    } else {
        window.history.back();
    }
}

// Called every time a screen becomes active
function handleScreenShow(screenId) {
    if (screenId === 'onboarding-handicap') {
        trackOnboardingEvent('onboarding_started', {
            source: 'shopify',
            timestamp: new Date().toISOString()
        });
        startTypewriterEffect();
    }

    if (screenId === 'onboarding-distance') {
        initCustomSlider();
    }

    if (screenId === 'onboarding-summary') {
        populateSummaryScreen();
        trackOnboardingEvent('onboarding_plan_summary_viewed', OnboardingData.get());
    }

    if (screenId === 'onboarding-calculating') {
        $('.calc-step').removeClass('completed active').addClass('pending');
        $('.calc-icon').html('<i class="fa fa-circle-o"></i>');
        startCalculatingAnimation();
    }
}

// ============================================================================
// PROGRESS BAR
// ============================================================================

function updateProgressBar(screenId) {
    var screenNum   = screenOrder.indexOf(screenId) + 1;
    var totalScreens = 10; // Only show progress for the 10 data-collection screens
    var progress    = Math.min((screenNum / totalScreens) * 100, 100);
    var displayNum  = Math.min(screenNum, totalScreens);

    $('.onboarding-progress-fill').css('width', progress + '%');
    $('.onboarding-progress-text').text(displayNum + ' of ' + totalScreens);
}

// ============================================================================
// ANALYTICS
// ============================================================================

function trackOnboardingEvent(eventName, properties) {
    properties = properties || {};
    if (window.amplitude && typeof window.amplitude.track === 'function') {
        window.amplitude.track(eventName, properties);
    }
    console.log('Quiz Event:', eventName, properties);
}

/**
 * Flush Amplitude before a hard navigation. Without this, events queued
 * right before window.location.href (e.g. quiz_completed) are often lost.
 */
function flushAmplitudeThen(callback, timeoutMs) {
    var done = false;
    function finish() {
        if (done) return;
        done = true;
        callback();
    }

    setTimeout(finish, timeoutMs || 2000);

    if (window.amplitude && typeof window.amplitude.flush === 'function') {
        try {
            var result = window.amplitude.flush();
            if (result && typeof result.then === 'function') {
                result.then(finish).catch(finish);
                return;
            }
        } catch (e) {
            console.warn('Amplitude flush failed:', e);
        }
    }

    // No flush available — give the network a short beat before navigating
    setTimeout(finish, 300);
}

// ============================================================================
// SCREEN HANDLERS
// ============================================================================

// Screen 1
function handleHandicapSubmit() {
    var handicapVal  = $('#onboarding-handicap-input').val();
    var typicalScore = $('#onboarding-typical-score').val();

    OnboardingData.set({
        handicap:     handicapVal  ? parseFloat(handicapVal)  : null,
        typicalScore: typicalScore ? parseInt(typicalScore)    : null
    });
    OnboardingData.completeScreen(1);

    trackOnboardingEvent('onboarding_handicap_entered', {
        handicap:     handicapVal,
        typicalScore: typicalScore
    });

    goToNextScreen('onboarding-handicap');
}

// Screen 2
function handleFrustrationSelect(value) {
    OnboardingData.set({ frustration: value, focusArea: getFocusArea(value) });
    OnboardingData.completeScreen(2);
    trackOnboardingEvent('onboarding_frustration_selected', { frustration: value });
    goToNextScreen('onboarding-frustration');
}

// Screen 3
function handleTempoTypeSelect(value) {
    OnboardingData.set({ swingTempoType: value });
    OnboardingData.completeScreen(3);
    trackOnboardingEvent('onboarding_tempo_type_selected', { swingTempoType: value });
    goToNextScreen('onboarding-tempo-type');
}

// Screen 4
function handleGolferTypeSelect(value) {
    OnboardingData.set({ golferType: value });
    OnboardingData.completeScreen(4);
    trackOnboardingEvent('onboarding_golfer_type_selected', { golferType: value });
    goToNextScreen('onboarding-golfer-type');
}

// Screen 5
function handleLessonsSelect(value) {
    OnboardingData.set({ takesLessons: value });
    OnboardingData.completeScreen(5);
    trackOnboardingEvent('onboarding_lessons_selected', { takesLessons: value });
    goToNextScreen('onboarding-lessons');
}

// Screen 6
function handlePracticeSelect(value) {
    OnboardingData.set({ practiceFrequency: value });
    OnboardingData.completeScreen(6);
    trackOnboardingEvent('onboarding_practice_selected', { practiceFrequency: value });
    goToNextScreen('onboarding-practice');
}

// Screen 7
function handleBackswingSelect(value) {
    OnboardingData.set({ backswingPosition: value });
    OnboardingData.completeScreen(7);

    $('.backswing-option').removeClass('selected');
    $('[data-backswing="' + value + '"]').addClass('selected');

    trackOnboardingEvent('onboarding_backswing_selected', { backswingPosition: value });

    setTimeout(function() {
        goToNextScreen('onboarding-backswing');
    }, 300);
}

// Screen 8
function handleDistanceSubmit() {
    var distance = parseInt($('#onboarding-distance-slider').val());
    OnboardingData.set({ nineIronDistance: distance });
    OnboardingData.completeScreen(8);
    trackOnboardingEvent('onboarding_distance_entered', { nineIronDistance: distance });
    goToNextScreen('onboarding-distance');
}

// Screen 9
function handleGoalSelect(value) {
    OnboardingData.set({ primaryGoal: value });
    OnboardingData.completeScreen(9);
    trackOnboardingEvent('onboarding_goal_selected', { primaryGoal: value });
    goToNextScreen('onboarding-goal');
}

// ============================================================================
// SCREEN 10: SUMMARY — populate values
// ============================================================================

function populateSummaryScreen() {
    var data = OnboardingData.get();

    var frustrationMap = {
        'ball_striking': 'Poor Ball Striking',
        'distance':      'Lack of Distance',
        'putting':       'Putting Problems',
        'short_game':    'Short Game Struggles',
        'inconsistency': 'Club-to-Club Inconsistency',
        'driver':        'Off-the-Tee Struggles'
    };
    var tempoTypeMap = {
        'quick':   'Quick and aggressive',
        'smooth':  'Smooth and rhythmic',
        'slow':    'Slow and deliberate',
        'unknown': 'Not sure yet'
    };
    var golferTypeMap = {
        'beginner':    'Beginner',
        'casual':      'Casual',
        'improving':   'Improving',
        'serious':     'Serious',
        'competitive': 'Competitive'
    };
    var practiceMap = {
        'daily':            'Daily',
        '2-3-times':        '2-3 times per week',
        'once-week':        'Once a week',
        'few-times-month':  'A few times per month',
        'just-play':        'I mostly just play'
    };
    var backswingMap = {
        'short':    'Short of Parallel',
        'parallel': 'Parallel',
        'past':     'Past Parallel'
    };
    var goalMap = {
        'repeatable_swing': 'Build a Repeatable Swing',
        'score_improvement':'Lower My Scores',
        'ball_striking':    'Hit It Pure More Often',
        'distance':         'Gain Distance',
        'putting':          'Make More Putts',
        'short_game':       'Dial In My Short Game'
    };

    $('#summary-frustration').text(frustrationMap[data.frustration]         || '-');
    $('#summary-handicap').text(data.handicap !== null ? data.handicap      : 'Not set');
    $('#summary-typical-score').text(data.typicalScore                      || '-');
    $('#summary-tempo-type').text(tempoTypeMap[data.swingTempoType]         || '-');
    $('#summary-golfer-type').text(golferTypeMap[data.golferType]           || '-');
    $('#summary-lessons').text(data.takesLessons === 'yes' ? 'Yes' : data.takesLessons === 'no' ? 'No' : '-');
    $('#summary-practice').text(practiceMap[data.practiceFrequency]         || '-');
    $('#summary-backswing').text(backswingMap[data.backswingPosition]       || '-');
    $('#summary-distance').text(data.nineIronDistance ? data.nineIronDistance + ' yards' : '-');
    $('#summary-goal').text(goalMap[data.primaryGoal]                       || '-');
}

// ============================================================================
// SCREEN 11: CALCULATING ANIMATION
// ============================================================================

function startCalculatingAnimation() {
    var steps = [
        { id: 'calc-step-1' },
        { id: 'calc-step-2' },
        { id: 'calc-step-3' },
        { id: 'calc-step-4' }
    ];

    var currentStep  = 0;
    var stepDuration = 1000;

    function animateStep() {
        if (currentStep < steps.length) {
            var stepId = steps[currentStep].id;
            $('#' + stepId).removeClass('pending active').addClass('completed');
            $('#' + stepId + ' .calc-icon').html('<i class="fa fa-check"></i>');
            currentStep++;

            if (currentStep < steps.length) {
                $('#' + steps[currentStep].id).removeClass('pending').addClass('active');
            }
            setTimeout(animateStep, stepDuration);

        } else {
            // All steps done — calculate tempo, save to localStorage, redirect
            var data            = OnboardingData.get();
            var recommendations = getTempoRecommendations(data);

            OnboardingData.set({
                fullSwingTempo: recommendations.fullSwingTempo,
                puttingTempo:   recommendations.puttingTempo,
                primaryFocus:   recommendations.primaryFocus
            });
            OnboardingData.completeScreen(11);

            trackOnboardingEvent('quiz_completed', {
                fullSwingTempo: recommendations.fullSwingTempo,
                primaryGoal:    data.primaryGoal
            });

            if (window.fbq) fbq('track', 'Lead');
            if (window.ttq) ttq.track('SubmitForm');

            // Pass key values as URL params so the landing page can read them
            // without needing to parse localStorage
            var params = new URLSearchParams({
                tempo:        recommendations.fullSwingTempo || 144,
                puttingTempo: recommendations.puttingTempo   || 135,
                goal:         data.primaryGoal               || '',
                focus:        recommendations.primaryFocus   || 'full_swing'
            });

            // Flush Amplitude first — a hard redirect otherwise drops quiz_completed
            flushAmplitudeThen(function() {
                window.location.href = LANDING_PAGE_URL + '?' + params.toString();
            });
        }
    }

    $('#calc-step-1').removeClass('pending').addClass('active');
    setTimeout(animateStep, stepDuration);
}


// ============================================================================
// CUSTOM DISTANCE SLIDER (Screen 8)
// ============================================================================

function initCustomSlider() {
    var slider       = document.getElementById('custom-distance-slider');
    var handle       = document.getElementById('slider-handle');
    var fill         = document.getElementById('slider-fill');
    var input        = document.getElementById('onboarding-distance-slider');
    var valueDisplay = document.getElementById('distance-value');

    if (!slider || !handle) return;

    var min        = 80;
    var max        = 180;
    var isDragging = false;

    function updateSlider(percent) {
        percent = Math.max(0, Math.min(100, percent));
        var value = Math.round(min + (percent / 100) * (max - min));
        handle.style.left      = percent + '%';
        fill.style.width       = percent + '%';
        input.value            = value;
        valueDisplay.textContent = value + ' yards';
    }

    function getPercent(e) {
        var rect    = slider.getBoundingClientRect();
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        return ((clientX - rect.left) / rect.width) * 100;
    }

    var initialValue = parseInt(input.value) || 130;
    updateSlider(((initialValue - min) / (max - min)) * 100);

    handle.addEventListener('touchstart', function(e) { e.preventDefault(); isDragging = true; });
    slider.addEventListener('touchstart', function(e) { isDragging = true; updateSlider(getPercent(e)); });
    document.addEventListener('touchmove', function(e) {
        if (isDragging) { e.preventDefault(); updateSlider(getPercent(e)); }
    }, { passive: false });
    document.addEventListener('touchend', function() { isDragging = false; });

    handle.addEventListener('mousedown', function(e) { e.preventDefault(); isDragging = true; });
    slider.addEventListener('mousedown', function(e) { isDragging = true; updateSlider(getPercent(e)); });
    document.addEventListener('mousemove', function(e) { if (isDragging) updateSlider(getPercent(e)); });
    document.addEventListener('mouseup',   function()  { isDragging = false; });
}

// ============================================================================
// TYPEWRITER EFFECT (Screen 1)
// ============================================================================

function startTypewriterEffect() {
    var text        = "Let's figure out your swing tempo";
    var typewriterEl = document.getElementById('typewriter-text');
    var cursorEl     = document.querySelector('.typewriter-cursor');
    var formEl       = document.getElementById('handicap-form');

    if (!typewriterEl) return;

    typewriterEl.textContent = '';
    formEl.style.display     = 'none';
    formEl.style.opacity     = '0';
    if (cursorEl) cursorEl.style.display = 'inline';

    var charIndex = 0;

    function typeNextChar() {
        if (charIndex < text.length) {
            typewriterEl.textContent += text.charAt(charIndex);
            charIndex++;
            setTimeout(typeNextChar, 50 + Math.random() * 30);
        } else {
            setTimeout(function() {
                if (cursorEl) cursorEl.style.display = 'none';
                formEl.style.display = 'block';
                setTimeout(function() {
                    formEl.style.transition = 'opacity 0.5s ease';
                    formEl.style.opacity    = '1';
                }, 50);
            }, 300);
        }
    }

    setTimeout(typeNextChar, 500);
}

// ============================================================================
// INITIALIZATION
// ============================================================================

document.addEventListener('DOMContentLoaded', function() {
    OnboardingData.clear();
    OnboardingData.init();
    // Screen 1 is already visible via the 'active' class in the HTML;
    // just trigger its show handler to start the typewriter
    handleScreenShow('onboarding-handicap');
});

// ============================================================================
// GLOBAL EXPORTS
// ============================================================================

window.OnboardingData          = OnboardingData;
window.goToNextScreen          = goToNextScreen;
window.quizGoBack              = quizGoBack;
window.handleHandicapSubmit    = handleHandicapSubmit;
window.handleFrustrationSelect = handleFrustrationSelect;
window.handleTempoTypeSelect   = handleTempoTypeSelect;
window.handleGolferTypeSelect  = handleGolferTypeSelect;
window.handleLessonsSelect     = handleLessonsSelect;
window.handlePracticeSelect    = handlePracticeSelect;
window.handleBackswingSelect   = handleBackswingSelect;
window.handleDistanceSubmit    = handleDistanceSubmit;
window.handleGoalSelect        = handleGoalSelect;
